export default __webpack_public_path__ + "static/media/julien.1b07b6d5.jpg";